import { useUser } from "@saleor/auth";
import { isStaffRole } from "@saleor/auth/hooks/useUserRole";
import AppHeader from "@saleor/components/AppHeader";
import Container from "@saleor/components/Container";
import PageHeader from "@saleor/components/PageHeader";
import ViewContractPage from "@saleor/createOrder/components/ViewContractPage";
import {
  useContractQuery,
  useScgpCustomerContractQuery
} from "@saleor/graphql";
import useNavigator from "@saleor/hooks/useNavigator";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";

import {
  ContracDetailQueryParams,
  contractDetailUrl,
  contractUrl
} from "../urls";

interface SoldToListProps {
  id: string;
  params: ContracDetailQueryParams;
}

const ContractDetail: React.FC<SoldToListProps> = ({ id, params }) => {
  const intl = useIntl();
  const navigate = useNavigator();
  const { user } = useUser();
  const { data } = useContractQuery({
    displayLoader: true,
    variables: {
      id
    },
    skip: !user?.isStaff
  });

  const { data: dataCustomer } = useScgpCustomerContractQuery({
    displayLoader: true,
    variables: {
      id
    },
    skip: user?.isStaff
  });

  const handleBack = () => {
    navigate(
      contractUrl(user?.isStaff ? data?.contract?.customer?.code ?? "" : "")
    );
  };

  useEffect(
    () =>
      navigate(
        contractDetailUrl(id, {
          ...params
        }),
        { replace: true }
      ),
    []
  );
  return (
    <Container>
      <AppHeader onBack={handleBack}>
        {intl.formatMessage({ defaultMessage: "กลับไป" })}
      </AppHeader>
      <PageHeader
        title={
          isStaffRole()
            ? intl.formatMessage({ defaultMessage: "เลือกสินค้า" })
            : intl.formatMessage({ defaultMessage: "Contract Details" })
        }
      />
      <ViewContractPage
        data={data?.contract}
        dataCustomer={dataCustomer?.scgpCustomerContract}
      />
    </Container>
  );
};

export default ContractDetail;
